export class SortObject{
    key: string;
    value: string;
}